module.exports = __webpack_public_path__ + "static/media/inf_05og06.5aac0cc2.mp3";